module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3c8f1fdb57481913036cb3581e84bc72.png";